import React, { useEffect, useState } from "react";
import Ressetting from "./Ressetting";
import { Button, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip,} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import api from "../../features/auth/axiosConfig";
import Resheader from "../../business-types/restaurant/modules/home/Resheader";
import Resmenu from "../../business-types/restaurant/modules/home/Resmenu";

interface ResCategory {
  _id: { $oid: string };
  CategoryName: string;
}
interface Product {
  _id: { $oid: string };
  category_id: string ;
}

const Rescategory = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [categoryName, setCategoryName] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [categories, setCategories] = useState<ResCategory[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState<string | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [products, setProducts] = useState<Product[]>([]);
  useEffect(() => {
    fetchCategories();
    fetchProducts();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await api.get("/app/v1/pos/category");
      setCategories(response.data.result);
    } catch {
      toast.error("Failed to fetch categories.", { theme: "colored" });
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await api.get("/app/v1/pos/product");
      setProducts(response.data.result);
    } catch {
      toast.error("Failed to fetch products.", { theme: "colored" });
    }
  };

  const handleAddOrEditCategory = async () => {
    if (!categoryName.trim()) {
      toast.error("Category name is required.", { theme: "colored" });
      return;
    }

    setLoading(true);
    try {
      if (isEditing && currentCategoryId) {
        await api.put(`/app/v1/pos/category/${currentCategoryId}`, {
          CategoryName: categoryName,
        });
        toast.success("Category updated successfully.", { theme: "colored" });
      } else {
        await api.post("/app/v1/pos/category", { CategoryName: categoryName });
        toast.success("Category added successfully.", { theme: "colored" });
      }
      fetchCategories();
      closeModal();
    } catch (error) {
      //   toast.error(
      //     error.response?.status === 403
      //       ? "Category name already exists."
      //       : "Failed to save category.",
      //     { theme: "colored" }
      //   );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCategory = async () => {
    if (!currentCategoryId) return;

    setLoading(true);
    try {
      await api.delete(`/app/v1/pos/category/${currentCategoryId}`);
      toast.success("Category deleted successfully.", { theme: "colored" });
      fetchCategories();
      closeModal();
    } catch {
      toast.error("Failed to delete category.", { theme: "colored" });
    } finally {
      setLoading(false);
    }
  };

  const openModal = (
    action: "add" | "edit" | "delete",
    category?: ResCategory
  ) => {
    setModalVisible(true);
    if (action === "edit" && category) {
      setIsEditing(true);
      setIsDeleting(false);
      setCurrentCategoryId(category._id.$oid);
      setCategoryName(category.CategoryName);
    } else if (action === "delete" && category) {
      setIsEditing(false);
      setIsDeleting(true);
      setCurrentCategoryId(category._id.$oid);
      setCategoryName(category.CategoryName);
    } else {
      setIsEditing(false);
      setIsDeleting(false);
      setCurrentCategoryId(null);
      setCategoryName("");
    }
  };

  const closeModal = () => {
    setModalVisible(false);
    setCategoryName("");
    setCurrentCategoryId(null);
    setIsEditing(false);
    setIsDeleting(false);
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const oldOrders =()=>{
  }
  
  const getProductCount = (categoryId: string) => {
    return products.filter((product) => product.category_id === categoryId)
      .length;
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}
    >
      <Resheader Resheader={"Categorys"} OldOrders={oldOrders} />
      <div style={{ display: "flex" }}>
        <Resmenu Resmenu={""} />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Ressetting />
          <div>
            <div className="addcatpgory-button">
              <Button
                variant="contained"
                color="primary"
                onClick={() => openModal("add")}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Add Category"}
              </Button>
            </div>
          </div>
          <div className="body-of-table">
            <TableContainer component={Paper} className="catogory-table">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-header-restarunt">
                      S.No
                    </TableCell>
                    <TableCell className="table-header-restarunt">
                      Categories
                    </TableCell>
                    <TableCell className="table-header-restarunt">
                      No.of.products
                    </TableCell>
                    <TableCell className="table-header-restarunt">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {categories.length > 0 ? (
                    categories
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((category, index) => (
                        <TableRow key={category._id.$oid}>
                          <TableCell>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell>{category.CategoryName}</TableCell>
                          <TableCell>{getProductCount(category._id.$oid)}</TableCell>
                          <TableCell>
                            <Tooltip title="Edit">
                              <IconButton
                                onClick={() => openModal("edit", category)}
                              >
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={() => openModal("delete", category)}
                                style={{ color: "red" }}
                              >
                                <DeleteOutlineIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No categories available.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15, { label: "All", value: -1 }]}
                component="div"
                count={categories.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </TableContainer>
          </div>
          {modalVisible && (
            <div className="modal-overlay">
              <div className="modal-content">
                {isEditing && !isDeleting ? (
                  <>
                    <h3 className="edit-category-restarunt">Edit Category</h3>
                    <TextField
                     style={{ marginTop: "10px",width:"350px" }}
                      label="Category Name"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                      fullWidth
                    />
                    <div className="button-container">

                      <Button onClick={closeModal} disabled={loading}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddOrEditCategory}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} /> : "update"}
                      </Button>
                    </div>
                  </>
                ) : isDeleting ? (
                  <>
                    <h3 className="delete-catagory-heading">Delete Category</h3>
                    <p style={{marginTop:"10px"}}>Are you sure you want to delete this category?</p>
                    <div className="button-container">
                      <Button onClick={closeModal} disabled={loading}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleDeleteCategory}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} /> : "Delete"}
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <h3 className="add-category-heading">Add Category</h3>
                    <TextField
                      style={{ marginTop: "10px",width:"350px" }}
                      className="add-button-textfield"
                      label="Category Name"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                      fullWidth
                    />
                    <div className="button-container">
                      <Button
                        onClick={closeModal}
                        variant="text"
                        disabled={loading}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddOrEditCategory}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} /> : "Add"}
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          <ToastContainer autoClose={1000} />
        </div>
      </div>
    </div>
  );
};

export default Rescategory;
